import * as types from './types'

const actions = {
  setQueryIndex ({ commit }, { index }) {
    commit(types.SET_QUERY_INDEX, { index })
  },
  setFilterQuery ({ commit, dispatch }, {index,  query }) {
    dispatch('pagination/setPaginationPage', { page: 0 }, { root: true })
    commit(types.SET_QUERY_INDEX, { index })
    commit(types.SET_QUERY_FILTERS, { query })
  },
  setReferenceFilterQuery ({ commit, dispatch }, {index,  reference }) {
    dispatch('refinementListFilters/removeAllFacetValues', { notClearable: [] }, { root: true })
    dispatch('pagination/setPaginationPage', { page: 0 }, { root: true })
    dispatch('setFilterQuery', { query: null })
    commit(types.SET_QUERY_INDEX, { index })
    commit(types.SET_REFERENCE_QUERY_FILTERS, { reference })
  },
  setResetState ({ commit }) {
    commit(types.SET_RESET_STATE)
  }
}
export default actions
